// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-dashboard .quick-link .link-item {
  border-bottom: 1px solid #c0c9d7;
}
.app-dashboard .quick-link .link-item:last-child {
  border-bottom: 0;
}
.app-dashboard .fixed-height-col {
  -webkit-overflow-scrolling: touch;
  height: 200px;
  overflow: auto;
  position: relative;
  will-change: scroll-position;
}
.app-dashboard .refresh-btn-bg {
  background: #fdfdfd;
}
.app-dashboard .bg-blue .card-header {
  background: #4e8dd6;
}
.app-dashboard .bg-blue .card-header .card-title {
  color: #1e2732;
}
.app-dashboard .bg-blue .card-header .text-muted {
  color: #ffffff !important;
}
.app-dashboard .bg-orange .card-header {
  background: #d6904e;
}
.app-dashboard .bg-orange .card-header .card-title {
  color: #563a1f;
}
.app-dashboard .bg-orange .card-header .text-muted {
  color: #ffffff !important;
}
.app-dashboard .bg-grey .card-header {
  background: #978f87;
}
.app-dashboard .bg-grey .card-header .card-title {
  color: #322d28;
}
.app-dashboard .bg-grey .card-header .text-muted {
  color: #ffffff !important;
}
.app-dashboard .bg-classy .card-header {
  background: #a7c2ec;
}
.app-dashboard .bg-classy .card-header .card-title {
  color: #26292e;
}
.app-dashboard .bg-classy .card-header .text-muted {
  color: #3D4756 !important;
}
.app-dashboard .customer-dashboard .card-header {
  margin-bottom: 0.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAGQ;EACI,gCAAA;AAFZ;AAKQ;EACI,gBAAA;AAHZ;AAOI;EACI,iCAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;AALR;AASI;EACI,mBAAA;AAPR;AAWQ;EACI,mBAAA;AATZ;AAWY;EACI,cAAA;AAThB;AAYY;EACI,yBAAA;AAVhB;AAgBQ;EACI,mBAAA;AAdZ;AAgBY;EACI,cAAA;AAdhB;AAiBY;EACI,yBAAA;AAfhB;AAqBQ;EACI,mBAAA;AAnBZ;AAqBY;EACI,cAAA;AAnBhB;AAsBY;EACI,yBAAA;AApBhB;AA0BQ;EACI,mBAAA;AAxBZ;AA0BY;EACI,cAAA;AAxBhB;AA2BY;EACI,yBAAA;AAzBhB;AAgCQ;EACI,gCAAA;AA9BZ","sourcesContent":[".app-dashboard{\n\n    .quick-link {\n        .link-item {\n            border-bottom: 1px solid #c0c9d7;\n        }\n\n        .link-item:last-child {\n            border-bottom: 0;\n        }\n    }\n\n    .fixed-height-col {\n        -webkit-overflow-scrolling: touch;\n        height: 200px;\n        overflow: auto;\n        position: relative;\n        will-change: scroll-position\n    }\n  \n    // Header classes.\n    .refresh-btn-bg {\n        background: #fdfdfd; \n    }\n\n    .bg-blue {\n        .card-header {\n            background: #4e8dd6;\n\n            .card-title {\n                color: #1e2732;\n            }\n\n            .text-muted {\n                color: #ffffff !important;\n            }\n        }\n    }\n\n    .bg-orange {\n        .card-header {\n            background: #d6904e;\n\n            .card-title {\n                color: #563a1f;\n            }\n\n            .text-muted {\n                color: #ffffff !important;\n            }\n        }\n    }\n\n    .bg-grey {\n        .card-header {\n            background: #978f87;\n\n            .card-title {\n                color: #322d28;\n            }\n\n            .text-muted {\n                color: #ffffff !important;\n            }\n        }\n    }\n    \n    .bg-classy {\n        .card-header {\n            background: #a7c2ec;\n\n            .card-title {\n                color: #26292e;\n            }\n\n            .text-muted {\n                color: #3D4756 !important;\n            }\n        }\n    }\n\n\n    .customer-dashboard{\n        .card-header {\n            margin-bottom: 0.5rem!important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
